// extracted by mini-css-extract-plugin
export default {"icon":"StackIcon_icon__2PyPA"};